import { saveAs } from 'file-saver';
import { DateHelper } from '../../../helpers/dateHelper';
import DataTableGrid from '../../../shared/formUtilities/useTable';
import { ReportsService } from '../reportsService';
import { useState } from 'react';
import { InitializeColumnsInvestorsShareholders } from '../reportsColumn';
import { useEffect } from 'react';

export const CorporateInvestorShareholder = () => {
	const reportsService = new ReportsService();
	const [investors, setInvestors] = useState([]);
	const [loading, setloading] = useState(false);
	const columns = InitializeColumnsInvestorsShareholders();

	useEffect(() => {
		getAll();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getAll = () => {
		setloading(true);
		reportsService
			.getCorporateInvestorShareholders()
			.then((resp) => {
				setloading(false);
				setInvestors(resp.data);
			})
			.catch((err) => {
				setloading(false);
			});
	};

	const onDownloadCSV = () => {
		setloading(true);
		reportsService
			.exportInvestorShareholders()
			.then((resp) => {
				const date = DateHelper.formatDate(new Date());
				const fileName = `Investor-Shareholders-${date}.csv`;
				saveAs(resp.data, fileName);
				setloading(false);
			})
			.catch((err) => {
				setloading(false);
			});
	};

	return (
		<>
			<DataTableGrid
				showDownloadCSV={true}
				download={() => {
					onDownloadCSV();
				}}
				name={'CorporateInvestorsShareholderTbl'}
				columns={columns}
				heading={'Investor Shareholders'}
				records={investors}
				isPagination={false}
				showEditColumnsButton={true}
				loading={loading}></DataTableGrid>
		</>
	);
};
